export interface ListResponseModel<T> {
	pageIndex: number;
	count: number;
	totalPages: number;
	items: T;
  categories: T;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
}

export const toQueryString = <T extends object>(params: T): string => {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null)
      .map(([key, value]) => {
        if (value instanceof Date) {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString().split('T')[0])}`;
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
      })
      .join('&');
  
    return queryString ? `?${queryString}` : '';
  };